import css from "@styled-system/css";
import styled from "styled-components";
export * from "@neru/base/styles";

const BANNER_HEIGHT = 415;

export const PageBanner = styled.div(
  css({
    "& > h1": {
      color: "white",
      marginBottom: "lg",
      marginTop: 0,
      textAlign: "center",
    },
    ".p1": {
      backgroundColor: "#60EECC",
      borderRadius: "lg",
      boxShadow:
        "0px 2px 1px rgba(0, 0, 0, 0.05), 0px 1px 2px rgba(0, 0, 0, 0.05), 0px 1px 4px rgba(0, 0, 0, 0.1)",
      height: "5rem",
      marginLeft: "62rem",
      marginTop: "24rem",
      transform: "rotate(-22deg)",
      width: "5rem",
    },
    ".p10": {
      backgroundColor: "#FA7454",
      borderRadius: "sm",
      boxShadow:
        "0px 6px 8px rgba(0, 0, 0, 0.05), 0px 12px 16px rgba(0, 0, 0, 0.05), 0px 4px 24px rgba(0, 0, 0, 0.1)",
      height: "1.2rem",
      marginLeft: "-48rem",
      marginTop: "8rem",
      transform: "rotate(-6deg)",
      width: "1.2rem",
    },
    ".p11": {
      backgroundColor: "#FFF",
      borderRadius: "md",
      boxShadow:
        "0px 2px 1px 1px rgba(0, 0, 0, 0.25), 0px 1px 2px rgba(0, 0, 0, 0.25), 0px 1px 4px rgba(0, 0, 0, 0.25)",
      fontSize: "lg",
      height: "3rem",
      marginLeft: "-52rem",
      marginTop: "22rem",
      transform: "rotate(-6deg)",
      width: "3rem",
    },
    ".p12": {
      backgroundColor: "#FACC4B",
      borderRadius: "md",
      boxShadow:
        "0px 12px 16px rgba(0, 0, 0, 0.05), 0px 24px 32px rgba(0, 0, 0, 0.05), 0px 12px 48px rgba(0, 0, 0, 0.2)",
      height: "4rem",
      marginLeft: "-62rem",
      marginTop: "14rem",
      transform: "rotate(15deg)",
      width: "4rem",
    },
    ".p13": {
      backgroundColor: "#FB8FD8",
      borderRadius: "sm",
      height: "1.5rem",
      marginLeft: "-86rem",
      marginTop: "24rem",
      transform: "rotate(-18deg)",
      width: "1.5rem",
    },
    ".p2": {
      backgroundColor: "#BB1E89",
      borderRadius: "sm",
      height: "1.5rem",
      marginLeft: "49rem",
      marginTop: "24rem",
      transform: "rotate(-12deg)",
      width: "1.5rem",
    },
    ".p3": {
      backgroundColor: "#FB8FD8",
      borderRadius: "md",
      boxShadow:
        "0px 8px 12px rgba(0, 0, 0, 0.05), 0px 16px 24px rgba(0, 0, 0, 0.05), 0px 6px 32px rgba(0, 0, 0, 0.1)",
      height: "2.5rem",
      marginLeft: "54rem",
      marginTop: "16rem",
      transform: "rotate(30deg)",
      width: "2.5rem",
    },
    ".p4": {
      backgroundColor: "#0276D5",
      borderRadius: "md",
      boxShadow:
        "0px 2px 1px rgba(0, 0, 0, 0.05), 0px 1px 2px rgba(0, 0, 0, 0.05), 0px 1px 4px rgba(0, 0, 0, 0.1)",
      height: "2.4rem",
      marginLeft: "93rem",
      marginTop: "20rem",
      transform: "rotate(12deg)",
      width: "2.4rem",
    },
    ".p5": {
      backgroundColor: "#9941FF",
      borderRadius: "sm",
      height: "1.1rem",
      marginLeft: "60rem",
      marginTop: "-15rem",
      transform: "rotate(12deg)",
      width: "1.1rem",
    },
    ".p6": {
      backgroundColor: "white",
      borderRadius: "md",
      boxShadow:
        "0px 2px 1px 1px rgba(0, 0, 0, 0.25), 0px 1px 2px rgba(0, 0, 0, 0.25), 0px 1px 4px rgba(0, 0, 0, 0.25)",
      fontSize: "lg",
      height: "2.7rem",
      marginLeft: "54rem",
      marginTop: "-17rem",
      transform: "rotate(-18deg)",
      width: "2.7rem",
    },
    ".p7": {
      backgroundColor: "#440291",
      borderRadius: "sm",
      height: "1.5rem",
      marginLeft: "26rem",
      marginTop: "-24rem",
      width: "1.5rem",
    },
    ".p8": {
      backgroundColor: "#60CCEE",
      borderRadius: "sm",
      boxShadow:
        "0px 8px 12px rgba(0, 0, 0, 0.05), 0px 16px 24px rgba(0, 0, 0, 0.05), 0px 6px 32px rgba(0, 0, 0, 0.1)",
      height: "1.5rem",
      marginLeft: "16rem",
      marginTop: "26.5rem",
      transform: "rotate(25deg)",
      width: "1.5rem",
    },
    ".p9": {
      backgroundColor: "#FFEDFB",
      borderRadius: "sm",
      boxShadow:
        "0px 8px 12px rgba(0, 0, 0, 0.05), 0px 16px 24px rgba(0, 0, 0, 0.05), 0px 6px 32px rgba(0, 0, 0, 0.1)",
      height: "1.7rem",
      marginLeft: "5rem",
      marginTop: "22rem",
      opacity: 0.3,
      transform: "rotate(-25deg)",
      width: "1.7rem",
    },
    ".parts": {
      alignItems: "center",
      display: "flex",
      justifyContent: "center",
      position: "absolute",
    },
    alignItems: "center",
    background: "linear-gradient(90deg, #8728FB 4.86%, #FFA58B 96.11%);",
    boxSizing: "content-box",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    minHeight: BANNER_HEIGHT,
    overflowX: "clip",
    paddingX: "xl",
    paddingY: "md",
    position: "relative",
  }),
);
